import React from 'react';
import {
  Dimensions,
  PixelRatio,
  Platform,
  ScrollView,
  StyleSheet,
  View,
} from 'react-native';
import DashedLine from 'react-native-dashed-line';
import {getTaxDescription} from 'src/services/TranslationService';
import TransactionStore from 'src/stores/TransactionStore';
import AVText from '../../../elements/AVText';
import Styles from '../../../Styles';
import {
  BundleType,
  CartItem,
  TransactionDetail,
} from 'src/types/TransactionDetail';
import Localized from 'src/constants/AppStrings';
import AccountStore from 'src/stores/AccountStore';
import Settings from 'src/Settings';
import CartTypes from 'src/constants/cart/CartTypes';
import Util from 'src/Util';
import CartService from 'src/services/CartService';
import AccountConstants from 'src/constants/AccountConstants';
import ScreenContext from '../../../ScreenContext';
import {MenuProductType} from 'src/types/Menu';
import {CreditCard} from 'src/models/CreditCard';
import {connect} from 'react-redux';
import {RootState} from 'src/redux/store';
import {PreparationMethodValues} from 'src/types/PreparationMethods';
import {Identifier} from 'src/types/serverTypes/Account';
import {LocationType} from 'src/types/Location';

import PromotionTypes from 'src/constants/cart/PromotionTypes';
import CartProductItem from '../CartProductItem';
import ListCartEmpty from '../ListCartEmpty';
import CartItemBundle from '../CartItemBundle';
import MenuService from 'src/services/MenuService';
import {getDescriber} from 'src/components/screens/orderAhead/descriptor/DescriptorType';
import {getVATLabel} from 'src/constants/EUReceiptsTaxConstants';
import {scanAndPayTemplate} from '../templates/scanandPayThemeHelper';
import {TenderDiscount} from './TenderDiscount';
import AfterTaxPromo from './AfterTaxPromotion';
import UnlockDiscountCanteen from './UnlockDiscountCenteen';
import TagLightIcon from 'src/components/img/svg/TagLightIcon';
import {BarButton} from 'src/components/elements/orderAhead/BarButton';
import {isMenuProduct} from '../utils/isMenuProduct';
import {calculateFpSubtotalWithTaxes} from '../utils/helper';
import {
  withGlobalize,
  WithGlobalizeProps,
} from '../../../../i18n/HOC/withGlobalize';
import {Deposit} from './Deposit';

const width = Dimensions.get('screen').width;

const {
  getTransactionUpsellName,
  getTransactionUpsellProductsList,
  renderColorNutritionComponent,
  renderNutritionPromotionComponent,
} = getDescriber();

export type ListScanItemsCanteenProps = {
  balance: number;
  trashClick?: (itemNumbers: Array<number>) => void;
  editClicked?: (item: CartItem) => void;
  showGrandTotal: boolean;
  hideYourItems: boolean;
  cartType: CartTypes;
  checkoutDone: boolean;
  onAddItem?: () => void;
  locationId?: string;
  noteView?: React.ReactNode;
  preparationMethod: PreparationMethodValues;
  creditCards?: Array<CreditCard>;
  hasConsumerRoles: boolean;
  consumerRoleButton?: string;
  validateDiscountCode?: () => void;
  addDiscountToCart?: () => void;
  location?: LocationType;
  handleCheckoutClick?: () => void;
  discountCodeButtonAction?: () => void;
  saveDiscountCode?: (discountCode: string | null) => void;
  discountCodeSuccess?: boolean;
  discountCodeError?: boolean;
  changeToDefaultDiscount?: boolean;
  onChangeBtnPress?: () => void;
} & WithGlobalizeProps;

type ListScanItemsCanteenState = {
  transaction: TransactionDetail | null;
  displayItems: Array<CartItem>;
  consumerRoleIdentifier: Identifier | null;
};

class ListScanItemsCanteen extends React.Component<
  ListScanItemsCanteenProps,
  ListScanItemsCanteenState
> {
  static contextType = ScreenContext;
  declare context: React.ContextType<typeof ScreenContext>;
  cartScroller: ScrollView | null;

  constructor(props: ListScanItemsCanteenProps) {
    super(props);
    this.state = {
      transaction: TransactionStore.getTransaction(),
      displayItems: TransactionStore.getDisplayItems(),
      consumerRoleIdentifier: AccountStore.getConsumerIdentifier(),
    };
    this.onTransactionStoreChanged = this.onTransactionStoreChanged.bind(this);
    this.onAccountStoreChanged = this.onAccountStoreChanged.bind(this);
    this.onAddItemClick = this.onAddItemClick.bind(this);
    this.updateCart = this.updateCart.bind(this);
    this.getTitle = this.getTitle.bind(this);
    this.renderTransactionLevelUpsells =
      this.renderTransactionLevelUpsells.bind(this);
    this.renderRewardStatusTier = this.renderRewardStatusTier.bind(this);
  }

  componentDidMount() {
    AccountStore.addChangeListener(this.onAccountStoreChanged);
    TransactionStore.addChangeListener(this.onTransactionStoreChanged);
  }

  componentWillUnmount() {
    AccountStore.removeChangeListener(this.onAccountStoreChanged);
    TransactionStore.removeChangeListener(this.onTransactionStoreChanged);
  }

  onTransactionStoreChanged() {
    const transaction = TransactionStore.getTransaction();
    const displayItems = TransactionStore.getDisplayItems();
    if (!this.props.checkoutDone) {
      this.setState({
        transaction,
        displayItems,
      });
    }
  }
  onAccountStoreChanged() {
    const consumerRoleIdentifier = AccountStore.getConsumerIdentifier();
    if (!this.props.checkoutDone) {
      this.setState({
        consumerRoleIdentifier,
      });
    }
  }

  renderCartItem = (item: CartItem) => {
    return (
      <CartProductItem
        key={item.LineNumber}
        item={item}
        trashClick={this.props.trashClick}
        editClicked={this.props.editClicked}
        canEdit={this.props.cartType === CartTypes.OrderAhead}
        canDelete={this.props.cartType !== CartTypes.TouchlessCoffee}
      />
    );
  };
  getCartItems = (): Array<JSX.Element> => {
    let items: JSX.Element[] = [];
    const nonBundledItems = this.state.displayItems.filter(
      (item) => !item.IsInBundle,
    );

    if (nonBundledItems && nonBundledItems.length > 0) {
      items = nonBundledItems.map((item) => this.renderCartItem(item));
    }

    return items;
  };
  getBundles = (bundledItems: Array<CartItem>): Array<BundleType> => {
    const bundles: Array<BundleType> = [];
    bundledItems.forEach((item) => {
      const bundle = bundles.find(
        (innerBundle) => innerBundle.id === item.DiscountHeaderId,
      );

      if (!bundle) {
        let id = item.DiscountHeaderId;
        let title = item.DiscountDisplayName;

        if (!id) {
          id = 'id';
        }

        if (!title) {
          title = 'title';
        }

        bundles.push({
          id,
          items: [item],
          lineNumber: item.LineNumber || 0,
          title,
        });
      } else {
        bundle.items.push(item);
      }
    });
    return bundles;
  };
  renderBundle = (bundle: BundleType) => {
    return (
      <CartItemBundle
        key={bundle.lineNumber}
        bundle={bundle}
        trashClick={this.props.trashClick}
      />
    );
  };
  getCartBundles = () => {
    let renderedBundles: JSX.Element[] = [];
    const bundledItems = this.state.displayItems.filter(
      (item) => item.IsInBundle,
    );

    if (bundledItems && bundledItems.length > 0) {
      const bundles = this.getBundles(bundledItems);
      renderedBundles = bundles.map((bundle) => this.renderBundle(bundle));
    }

    return renderedBundles;
  };

  getCartContents = (): Array<JSX.Element> => {
    const items = this.getCartItems();
    const bundles = this.getCartBundles();
    return bundles.concat(items);
  };

  async updateCart(
    items: Array<CartItem>,
    scancode?: string,
    discountCode?: string,
  ) {
    this.context.actions.showSpinner();
    await CartService.updateCart(
      this.props.locationId ?? '',
      AccountStore.getAccountId(),
      [],
      items,
      AccountConstants.SOS_LOCATION_TYPE,
      scancode || '',
      TransactionStore.getPickupTime(),
      this.props.preparationMethod,
      this.context,
      discountCode,
    );
    this.context.actions.hideSpinner();
  }

  // This is called only for Upsell items
  onAddItemClick(item: MenuProductType) {
    const items = [...TransactionStore.getAllItems()];
    items.unshift({
      BarCode: item.scancode,
      Modifiers: [],
      PrintGroups: item.printgroups,
      Upsell: true,
    });
    const discountCode =
      this.props.location?.locationFeatures.is365PayAfterTaxPromo &&
      TransactionStore.isAfterTaxPromoApplied()
        ? PromotionTypes.AfterTaxPromo
        : null;
    this.updateCart(items, item.scancode, discountCode || '');
  }

  getTitle(item: MenuProductType) {
    if (item.price) {
      const price = item.price;

      if (price > 0) {
        return `${item.name} (+${Util.formatCurrency(
          this.props,
          price,
          AccountStore.getCurrency(),
        )})`;
      }
    }

    return item.name;
  }

  getPrice(item: MenuProductType) {
    if (item.price) {
      const price = Util.formatCurrency(
        this.props,
        item.price,
        AccountStore.getCurrency(),
      );
      return price;
    }
    return 0;
  }

  getLocationName() {
    if (this.props.cartType === CartTypes.ScanAndPay) {
      return (
        <AVText
          accessible={true}
          accessibilityLabel={this.props.location.name}
          aria-label={this.props.location.name}
          style={styles.locationName}
        >
          {this.props.location.name}
        </AVText>
      );
    } else {
      return null;
    }
  }

  getDashedLine() {
    return (
      <DashedLine
        dashGap={PixelRatio.roundToNearestPixel(2)}
        dashLength={PixelRatio.roundToNearestPixel(3)}
        dashThickness={PixelRatio.roundToNearestPixel(1)}
        dashColor={Styles.Colors.PayNew.neutralHuesBase09}
        style={styles.dashStyle}
      />
    );
  }

  renderTransactionLevelUpsells() {
    const raw = TransactionStore.getUpsellItems();

    if (
      this.props.cartType !== CartTypes.OrderAhead ||
      !Array.isArray(raw) ||
      raw.length === 0
    ) {
      return null;
    }

    const upsellProductsInMenu: MenuProductType[] = raw
      .map((u) => {
        const product = MenuService.getProductByScanCode(u.ScanCode);
        return product
          ? {
              ...product,
              RewardPoints: u.RewardPoints,
            }
          : null;
      })
      .filter(isMenuProduct)
      .slice(0, TransactionStore.getUpsellMaxItems());

    if (upsellProductsInMenu.length === 0) {
      return null;
    }

    return (
      <View>
        <View style={styles.container}>{this.getDashedLine()}</View>
        {getTransactionUpsellName(TransactionStore.getUpsellName())}
        {getTransactionUpsellProductsList(
          upsellProductsInMenu,
          this.onAddItemClick,
          this.props.location?.locationFeatures?.dna,
          this.props,
        )}
      </View>
    );
  }

  renderColorNutritionComponent() {
    const nutritionDisplayColor = this.state.transaction?.NutritionDisplayColor;
    const nutritionDisplayLetter =
      this.state.transaction?.NutritionDisplayLetter;
    const nutritionCalorieTotal = parseFloat(
      `${this.state.transaction?.TotalCalories ?? '0'}`,
    );
    return renderColorNutritionComponent(
      nutritionDisplayColor,
      nutritionDisplayLetter,
      nutritionCalorieTotal,
    );
  }

  renderNutritionPromotionComponent() {
    const nutritionDiscountAmount = parseFloat(
      this.state.transaction?.NutritionDiscountAmount,
    );

    return nutritionDiscountAmount > 0
      ? renderNutritionPromotionComponent(
          this.state.transaction?.NutritionPromoName,
          nutritionDiscountAmount,
        )
      : null;
  }

  renderRewardStatusTier() {
    return (
      this.state.transaction?.PointsToQualify > 0 &&
      this.state.transaction?.NextTierName && (
        <View style={styles.rewardsPointsView}>
          <AVText style={styles.pointsViewText}>
            {Localized.Labels.rewards_your_just}{' '}
            <AVText style={styles.pointsViewTextSub}>
              {this.state.transaction?.PointsToQualify}{' '}
              {Localized.Labels.points.toLowerCase()}
            </AVText>{' '}
            {
              Localized.Labels.formatString(
                Localized.Labels.rewards_status_tier,
                this.state.transaction?.NextTierName,
              ) as string
            }
          </AVText>
        </View>
      )
    );
  }

  render() {
    const items = this.getCartContents();

    const euTaxLabel = getVATLabel(this.props?.location?.country) ?? null;

    if (items.length === 0 && !this.props.checkoutDone) {
      return (
        <ListCartEmpty
          cartType={this.props.cartType}
          showCustomText={Settings.isCanteen()}
          location={this.props.location}
        />
      );
    }

    const totalEUTaxtoShow = this.state.transaction.Taxes.reduce(
      (sum, tax) => sum + parseFloat(tax.TaxAmount),
      0,
    );

    let due = 0;

    if (this.state.transaction && this.state.transaction.Due) {
      due = parseFloat(this.state.transaction.Due);
    }

    const afterTaxDiscount = parseFloat(
      this.state.transaction?.AfterTaxDiscount ?? '0',
    );
    const fpSubtotalWithTaxes = calculateFpSubtotalWithTaxes({
      taxes: this.state.transaction.Taxes,
      fpSubTotal: this.state.transaction.FPSubTotal,
    });

    const promotionDiscount = parseFloat(
      this.state.transaction?.PromotionDiscount ?? '0',
    );

    // ─── Helper: true when an order-level promo exists ────────────────────────
    const hasPromotion =
      promotionDiscount > 0 && promotionDiscount !== afterTaxDiscount;
    const totalPointsEarned = this.state.transaction?.Points;
    const netDiscount =
      TransactionStore.isAfterTaxPromoApplied() && afterTaxDiscount > 0
        ? promotionDiscount - afterTaxDiscount
        : promotionDiscount;
    return (
      <>
        <View style={scanAndPayTemplate.checkoutStyles.checkoutItemsMargin}>
          {this.getLocationName()}
          <View>
            {scanAndPayTemplate.showYourOrderLabel &&
              this.props.cartType === CartTypes.OrderAhead && (
                <AVText
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm11}
                  accessible={true}
                  accessibilityLabel={Localized.Labels.your_order}
                  aria-label={Localized.Labels.your_order}
                  style={styles.yourOrderLabel}
                >
                  {Localized.Labels.your_order}
                </AVText>
              )}
            {items}
            <View style={styles.colorNutritionStyle}>
              {this.renderColorNutritionComponent()}
            </View>
            {this.renderRewardStatusTier()}
          </View>
        </View>

        {this.renderTransactionLevelUpsells()}
        <View style={styles.container}>
          {this.getDashedLine()}

          <View style={styles.transactionItemsView}>
            {this.renderNutritionPromotionComponent()}
          </View>

          <View
            style={[
              styles.subTotalView,
              scanAndPayTemplate.checkoutStyles.subtotalSection,
            ]}
          >
            <AVText
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
              accessible={true}
              accessibilityRole="text"
              accessibilityLabel={Localized.Labels.subtotal}
              aria-label={Localized.Labels.subtotal}
              style={styles.transactionItemsSubtotal}
              testID="qa_Checkout.SubtotalLabel_txt"
              nativeID="qa_Checkout.SubtotalLabel_txt"
            >
              {Localized.Labels.subtotal}
            </AVText>
            <AVText
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
              accessible={true}
              accessibilityRole="text"
              accessibilityLabel={Localized.Labels.subtotal}
              aria-label={Localized.Labels.subtotal}
              style={styles.transactionItemsSubtotal}
              testID="qa_Checkout.SubtotalValue_txt"
              nativeID="qa_Checkout.SubtotalValue_txt"
            >
              {Util.formatCurrency(
                this.props,
                fpSubtotalWithTaxes,
                AccountStore.getCurrency(),
              )}
            </AVText>
          </View>
          <Deposit
            transaction={this.state.transaction}
            listProps={this.props}
          />
          {euTaxLabel ? (
            <View
              style={[
                styles.transactionItemsView,
                scanAndPayTemplate.checkoutStyles.subtotalSection,
              ]}
            >
              <AVText
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
                accessible={true}
                accessibilityRole="text"
                accessibilityLabel={'Tax'}
                aria-label={'Tax'}
                style={styles.transactionItemsSubtotal}
                testID="qa_Checkout.TaxLabel_txt"
                nativeID="qa_Checkout.TaxLabel_txt"
              >
                {`${euTaxLabel} ${Localized.Labels.total}`}
              </AVText>
              <AVText
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
                accessible={true}
                accessibilityRole="text"
                accessibilityLabel={`${euTaxLabel} ${
                  Localized.Labels.total
                } ${Util.formatCurrency(
                  this.props,
                  Number(totalEUTaxtoShow),
                  AccountStore.getCurrency(),
                )}`}
                aria-label={`${euTaxLabel} ${
                  Localized.Labels.total
                } ${Util.formatCurrency(
                  this.props,
                  Number(totalEUTaxtoShow),
                  AccountStore.getCurrency(),
                )}`}
                style={[styles.transactionItemsSubtotal]}
                testID="qa_Checkout.TaxValue_txt"
                nativeID="qa_Checkout.TaxValue_txt"
              >
                {Util.formatCurrency(
                  this.props,
                  Number(totalEUTaxtoShow),
                  AccountStore.getCurrency(),
                )}
              </AVText>
            </View>
          ) : (
            this.state.transaction?.Taxes.map((cur, i) => (
              <View
                style={[
                  styles.transactionItemsView,
                  scanAndPayTemplate.checkoutStyles.subtotalSection,
                ]}
                key={i}
              >
                <AVText
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
                  accessible={true}
                  accessibilityRole="text"
                  accessibilityLabel={'Tax'}
                  aria-label={'Tax'}
                  style={styles.transactionItemsSubtotal}
                  testID={`qa_Checkout.${getTaxDescription(
                    Localized,
                    cur.Description,
                  )}Label_txt`}
                >
                  {getTaxDescription(Localized, cur.Description)}
                </AVText>
                <AVText
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
                  accessible={true}
                  accessibilityRole="text"
                  accessibilityLabel={'Sub total'}
                  aria-label={'Sub total'}
                  style={[styles.transactionItemsSubtotal]}
                  testID={`qa_Checkout.${getTaxDescription(
                    Localized,
                    cur.Description,
                  )}Value_txt`}
                >
                  {Util.formatCurrency(
                    this.props,
                    Number(cur.TaxAmount),
                    AccountStore.getCurrency(),
                  )}
                </AVText>
              </View>
            ))
          )}

          {hasPromotion && (
            <View style={styles.totalDiscountsView}>
              <View style={styles.discountView}>
                <TagLightIcon
                  fill={scanAndPayTemplate.discountTagColor}
                  width={Styles.Spacing.m3}
                  height={Styles.Spacing.m3 + Styles.Spacing.m1}
                />
                <AVText
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
                  accessible={true}
                  accessibilityRole="text"
                  accessibilityLabel={Localized.Labels.discounts}
                  aria-label={Localized.Labels.discounts}
                  style={[styles.totalDiscountText, styles.padding]}
                  testID="qa_Checkout.DiscountsLabel_txt"
                  nativeID="qa_Checkout.DiscountsLabel_txt"
                >
                  {Localized.Labels.discounts}
                </AVText>
              </View>

              <AVText
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm5}
                accessible={true}
                accessibilityRole="text"
                accessibilityLabel={Localized.Labels.discounts}
                aria-label={Localized.Labels.discounts}
                style={styles.totalDiscountText}
                testID="qa_Checkout.DiscountsValue_txt"
                nativeID="qa_Checkout.DiscountsValue_txt"
              >
                {Util.formatCurrency(
                  this.props,
                  netDiscount * -1,
                  AccountStore.getCurrency(),
                )}
              </AVText>
            </View>
          )}

          {!this.props.location?.locationFeatures?.is365PayAfterTaxPromo && (
            <UnlockDiscountCanteen
              location={this.props.location}
              consumerRoleButton={this.props.consumerRoleButton}
              addDiscountToCart={this.props.addDiscountToCart}
              hasConsumerRoles={this.props.hasConsumerRoles}
              consumerRoleIdentifier={this.state.consumerRoleIdentifier}
              validateDiscountCode={this.props.validateDiscountCode}
              discountCodeButtonAction={this.props.discountCodeButtonAction}
              saveDiscountCode={this.props.saveDiscountCode}
              showSuccessMsg={this.props.discountCodeSuccess}
              showErrorMsg={this.props.discountCodeError}
              changeToDefaultDiscount={this.props.changeToDefaultDiscount}
              onChangeBtnPress={this.props.onChangeBtnPress}
            />
          )}

          {this.props.location?.locationFeatures?.is365PayAfterTaxPromo && (
            <AfterTaxPromo
              discount={afterTaxDiscount}
              onApply={this.props.addDiscountToCart}
              formatCurrency={(amt, cur) =>
                Util.formatCurrency(this.props, amt, cur)
              }
            />
          )}
          {this.getDashedLine()}

          <View style={styles.transactionTotalView}>
            <AVText
              maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm3}
              accessible={true}
              accessibilityRole="text"
              accessibilityLabel={Localized.Labels.total}
              aria-label={Localized.Labels.total}
              style={styles.transactionTotal}
              testID="qa_Checkout.YourTotalLabel_txt"
              nativeID="qa_Checkout.YourTotalLabel_txt"
            >
              {Localized.Buttons.your_total}
            </AVText>
            <View style={styles.totalAmountsView}>
              {hasPromotion && (
                <AVText
                  maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm3}
                  accessible={true}
                  accessibilityRole="text"
                  accessibilityLabel={'Sub total'}
                  aria-label={'Sub total'}
                  style={styles.transactionTotalWithoutDiscount}
                  testID="qa_Checkout.CrossedTotalValue_txt"
                  nativeID="qa_Checkout.CrossedTotalValue_txt"
                >
                  {Util.formatCurrency(
                    this.props,
                    fpSubtotalWithTaxes,
                    AccountStore.getCurrency(),
                  )}
                </AVText>
              )}
              <AVText
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm3}
                accessible={true}
                accessibilityRole="text"
                accessibilityLabel={'Sub total'}
                aria-label={'Sub total'}
                style={styles.transactionTotal}
                testID="qa_Checkout.TotalValue_txt"
                nativeID="qa_Checkout.TotalValue_txt"
              >
                {Util.formatCurrency(
                  this.props,
                  due,
                  AccountStore.getCurrency(),
                )}
              </AVText>
            </View>
          </View>
          {totalPointsEarned > 0 && (
            <View style={styles.pointsEarnedView}>
              <AVText
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm13}
                accessible={true}
                accessibilityRole="text"
                accessibilityLabel={Localized.Labels.points_earned_purchase}
                aria-label={Localized.Labels.points_earned_purchase}
                style={styles.rewardsPointsText}
                testID="qa_Checkout.PointsEarnedLabel_txt"
                nativeID="qa_Checkout.PointsEarnedLabel_txt"
              >
                {Localized.Labels.points_earned_purchase}
              </AVText>
              <AVText
                maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm13}
                accessible={true}
                accessibilityRole="text"
                accessibilityLabel={Localized.Labels.points}
                aria-label={Localized.Labels.points}
                style={styles.rewardPointsEarned}
                testID="qa_Checkout.PointsEarnedValue_txt"
                nativeID="qa_Checkout.PointsEarnedValue_txt"
              >
                {totalPointsEarned} {Localized.Labels.points.toLowerCase()}
              </AVText>
            </View>
          )}
        </View>

        <TenderDiscount
          transaction={this.state.transaction}
          listProps={this.props}
        />
        {items.length > 0 && (
          <View style={styles.payNowBtn}>
            <BarButton
              leftText={Localized.Labels.pay}
              onPress={this.props.handleCheckoutClick}
              buttonViewStyle={[styles.addBtnStyle]}
              containerStyle={styles.addBtnContainer}
              rightText={Util.formatCurrency(
                this.props,
                due,
                AccountStore.getCurrency(),
              )}
              textStyle={styles.addBtnText}
              testID="qa_Checkout.Pay_Btn"
            />
          </View>
        )}
      </>
    );
  }
}

const styles = StyleSheet.create({
  nutritionContainer: {
    marginHorizontal: Styles.Spacing.m3,
    marginVertical: Styles.Spacing.m2,
  },
  nutritionRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  nutritionPromotionRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: Styles.Spacing.m2,
  },
  promoIconContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  promoName: {
    color: Styles.Colors.PayNew.primary01,
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontSize: Styles.Fonts.f7,
  },
  promotionDiscount: {
    color: Styles.Colors.PayNew.primary01,
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontSize: Styles.Fonts.f7,
  },
  transactionTotalView: {
    flexDirection: 'row',
    marginTop: Styles.Spacing.m2,
    justifyContent: 'space-between',
    marginBottom: Platform.OS === 'web' ? Styles.Spacing.m2 : Styles.Spacing.m0,
  },
  subTotalView: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  totalDiscountsView: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: Styles.Spacing.m2,
  },
  transactionItemsView: {
    flexDirection: 'row',
    marginTop: Styles.Spacing.m1,
    justifyContent: 'space-between',
  },
  transactionPromoView: {
    marginTop: Styles.Spacing.m1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  transactionItemsText: {
    color: Styles.blackBase01,
    fontSize: Styles.Fonts.f7,
  },
  transactionPromoText: {
    color: Styles.Colors.PayNew.success,
    fontSize: Styles.Fonts.f7,
  },
  transactionItemsSubtotal: {
    color: Styles.Colors.PayNew.black01,
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontSize: Styles.Fonts.f1,
  },
  totalDiscountText: {
    color: scanAndPayTemplate.discountTagColor,
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontSize: Styles.Fonts.f1,
  },
  transactionTotal: {
    fontWeight: '700',
    color: Styles.Colors.PayNew.black01,
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontSize: Styles.Fonts.sectionHeader,
  },
  transactionTotalWithoutDiscount: {
    fontWeight: '700',
    color: Styles.Colors.PayNew.darkHuesBase04,
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontSize: Styles.Fonts.sectionHeader,
    marginRight: Styles.Spacing.m2,
    textDecorationLine: 'line-through',
  },
  locationName: {
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontSize: Styles.Fonts.f2,
    color: Styles.Colors.PayNew.black01,
    fontWeight: 'bold',
  },

  revolveTextLabelTotal: {
    fontSize: 32,
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontWeight: '400',
  },
  bottom: {
    height: Styles.Spacing.m3 + Styles.Spacing.m3,
  },
  container: {
    flex: 1,
    paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  dashStyle: {
    borderRadius: 100,
    height: PixelRatio.roundToNearestPixel(2),
    marginBottom: Styles.Spacing.m2,
    marginTop: Styles.Spacing.m2,
    overflow: 'hidden',
    width: '100%',
  },
  discountLabel: {
    color: Styles.darkColor,
    fontSize: Styles.Fonts.f1,
    fontWeight: '300',
  },
  discountSection: {
    flex: 1,
  },
  healthGrade: {},
  emptyContent: {
    alignSelf: 'stretch',
    flex: 1,
  },
  summaryContainer: {
    backgroundColor: 'red',
  },
  summaryTextContainer: {
    flex: 1,
    marginTop: Styles.Spacing.m1,
  },
  upsellContainer: {
    alignSelf: 'stretch',
    flexDirection: 'column',
  },
  upsellTitleText: {
    fontWeight: '600',
    fontSize: Styles.Fonts.f2,
    paddingLeft: Styles.Spacing.m2,
  },
  upsellItem: {
    flex: 1,
    flexDirection: 'row',
    paddingTop: Styles.Spacing.m1,
    paddingLeft: Styles.Spacing.m2,
  },
  upsellText: {
    marginRight: Styles.Spacing.m2,
    flex: 1,
    fontSize: Styles.Fonts.f1,
    fontWeight: '300',
    color: Styles.darkColor,
  },
  icon: {
    marginRight: Styles.Spacing.m2,
  },
  btnView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  btnDiscountCode: {
    alignSelf: 'flex-start',
    marginTop: Styles.Spacing.m2,
    marginRight: Styles.Spacing.m2,
  },
  btnEditCodeText: {
    color: Styles.primaryColor,
    marginLeft: Styles.Spacing.m1,
    textAlign: 'center',
    marginTop: Styles.Spacing.m2,
  },
  defaultLabel: {
    marginBottom: Styles.Spacing.m1,
    color: '#22212D',
    fontSize: 18,
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontWeight: 'bold',
    alignItems: 'flex-start',
    paddingLeft: Styles.Spacing.m1,
  },
  textFont: {
    fontFamily: scanAndPayTemplate.textFontFamily,
  },
  columnLabel: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: Styles.Spacing.m1,
    marginTop: Styles.Spacing.m3 + Styles.Spacing.m2,
    marginBottom: Styles.Spacing.m2,
  },
  columnAmount: {
    alignItems: 'flex-start',
  },
  yourOrderLabel: {
    fontSize: scanAndPayTemplate.subHeaderFontSize,
    fontWeight: '700',
    fontFamily: scanAndPayTemplate.textFontFamily,
    color: Styles.Colors.PayNew.black01,
  },
  colorNutritionStyle: {
    width: '100%',
    alignItems: 'flex-start',
    flexDirection: 'row',
  },
  dottedMarginStyle: {
    marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  totalAmountsView: {flexDirection: 'row'},
  addBtnStyle: {
    width: Platform.OS === 'web' ? '50%' : '100%',
    justifyContent: 'space-between',
    height: Styles.Heights.touchTargetHeight1 + 2,
    backgroundColor: scanAndPayTemplate.primaryColor,
  },
  addBtnContainer: {
    width: width,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
  addBtnText: {
    fontFamily: scanAndPayTemplate.textFontFamily,
    color: scanAndPayTemplate.payBtnColor,
    fontSize: Styles.Fonts.f1,
    fontWeight: '700',
  },
  payNowBtn: {
    marginHorizontal: Styles.Spacing.m3 + Styles.Spacing.m2,
    marginBottom: Styles.Spacing.m3 + Styles.Spacing.m2,
    marginTop: Styles.Heights.h3,
    alignSelf: 'center',
  },
  pointsEarnedView: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: Styles.Heights.h1,
    paddingBottom: Styles.Heights.h1,
  },
  rewardPointsEarned: {
    color: Styles.Colors.PayNew.black01,
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontSize: Styles.Fonts.f1,
    fontWeight: 'bold',
    fontStyle: 'italic',
  },
  rewardsPointsText: {
    color: Styles.Colors.PayNew.black01,
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontSize: Styles.Fonts.f1,
    fontStyle: 'italic',
  },
  rewardsPointsView: {
    marginTop: Styles.Spacing.m1,
  },
  pointsViewText: {
    fontWeight: '400',
    color: Styles.Colors.PayNew.black01,
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontSize: Styles.Fonts.f7,
    textAlign: 'center',
  },
  pointsViewTextSub: {
    fontWeight: '700',
    color: Styles.Colors.Canteen.green,
    fontFamily: scanAndPayTemplate.textFontFamily,
    fontSize: Styles.Fonts.f7,
  },
  discountView: {flexDirection: 'row', gap: Styles.Spacing.m1},
  padding: {
    marginTop: Platform.OS === 'android' ? 0 : 1,
  },
});

const ConnectedListScanItemsCanteen = connect((state: RootState) => ({
  creditCards: state.account.creditCards,
  consumerRoleIdentifier: state.account.account.consumerRoleIdentifier,
}))(ListScanItemsCanteen);

export default withGlobalize<ListScanItemsCanteenProps>(
  ConnectedListScanItemsCanteen,
);
